import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    tryAgain: string;
    permissionDenied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Generic error message when payment or billing update fails */
            tryAgain: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeFormError.tryAgain?c=2j9rawb98q40g", defaultMessage: "Something went wrong, please try again." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when user lacks permission to update billing */
            permissionDenied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeFormError.permissionDenied?c=9u4ozpri3wgm", defaultMessage: "You do not have permission to make this change." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
